import React from 'react';

/**
 * CustomizationsProvider component
 * Kept for tree structure compatibility.
 * Customizations data is now fed by useRealtimeSocket via Redux — no local listener needed.
 */
const CustomizationsProvider = ({ children }) => {
  return <>{children}</>;
};

export default CustomizationsProvider;
